{
  "version": 1,
  "asset_id": "00e082b3-8af3-4c67-8a6b-7b31f7304eee",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/00e082b3-8af3-4c67-8a6b-7b31f7304eee/destination-roofing-galvalume-metal-roof-inverness-fl-1320w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/00e082b3-8af3-4c67-8a6b-7b31f7304eee/destination-roofing-galvalume-metal-roof-inverness-fl-1320w.webp",
  "original_filename": "destination-roofing-galvalume-metal-roof-inverness-fl-1320w.webp",
  "size": 277020,
  "content_type": "image/webp",
  "created_at": "2026-07-16T20:37:24Z"
}
